<template>
  <div class="background-container">
    <div class="default-container">
      <div class="simple-header">
        <i @click="handlerClickBackButton"></i>
        <span>{{ computedHeaderTitle }}</span>
        <span class="home" @click="handlerClickHomeButton">홈으로</span>
      </div>
      <div id="boardViewPage">
        <p class="top" :class="setServiceClass">
          {{ setCategoryText }}
        </p>
        <p class="title">
          {{ board.title }}
        </p>
        <p class="subtitle" v-if="board.subtitle !== ''">
          {{ board.subtitle }}
        </p>
        <p class="info">
          <span class="category" :class="setServiceClass">
            {{ setCategoryText }}
          </span>
          <span v-if="setDateText !== ''" class="date">
            {{ setDateText }}
          </span>
        </p>
        <p class="button" v-if="isAdmin">
          <span>수정</span>
        </p>
        <div class="contents pc" v-html="board.contents"></div>
        <div
          v-if="board.contents_m !== ''"
          class="contents mo"
          v-html="board.contents_m"
        ></div>
        <div
          v-if="board.contents_m === ''"
          class="contents mo"
          v-html="board.contents"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'BoardViewPage',
  data() {
    return {
      isAdmin: window.homefit.grade === 'admin',
      board: {}
    }
  },
  created() {
    //call fetchBoard
    this.fetchBoard()
  },
  mounted() {
    axios.post('/api/associate/cookie/', { _method: 'post' })
    document.querySelector('.hf_layout_header_uikit_wrap').style.display =
      'none'
  },
  computed: {
    computedHeaderTitle() {
      if (this.board.service_type_caption === '공통') {
        return '';
      }
      return this.board.service_type_caption
    },
    setServiceClass() {
      return this.board.service_type !== undefined &&
        this.board.service_type !== ''
        ? this.board.service_type.toLowerCase()
        : ''
    },
    setCategoryText() {
      const serviceType =
        this.board.service_type === 'WORKOUT'
          ? '운동'
          : this.board.service_type === 'MEDITATION'
          ? '요가명상'
          : this.board.service_type === 'ART'
          ? '미술'
          : this.board.service_type === 'MUSIC'
          ? '음악'
          : ''

      switch (this.board.category) {
        case 'reported_news':
          return `언론보도 ${this.board.report_media_name}`
        case 'news':
          return '공지사항'
        case 'coach':
          return serviceType !== ''
            ? `${serviceType} 전문가 인터뷰`
            : '전문가 인터뷰'
        case 'case':
          return '회원 후기'
        case 'team':
          return '홈핏팀'
        case 'column':
          return '건강칼럼'
        case 'coach_notice':
          return '전문가 공지'
        case 'event':
          return serviceType !== '' ? `${serviceType} 이벤트` : '이벤트'
        case 'job':
          return serviceType !== '' ? `${serviceType} 채용` : '채용'
        default:
          return ''
      }
    },
    setDateText() {
      let str = ''
      switch (this.board.category) {
        case 'reported_news':
          str =
            this.board.reporting_date === null
              ? ''
              : `${this.board.reporting_date}`
          break
        case 'news':
          str =
            this.board.effective_date === null
              ? ''
              : `시행일 ${this.board.effective_date}`
          break
        case 'coach':
          str =
            this.board.coach_interview_name !== ''
              ? `${this.board.coach_interview_name} 전문가`
              : ''
          break
        case 'case':
          str =
            this.board.user_name !== '' ? `${this.board.user_name} 회원` : ''
          break
        case 'team':
          str =
            this.board.team_member_name !== ''
              ? `${this.board.team_member_name}님 인터뷰`
              : ''
          break
        case 'event':
          str = this.getDday(
            this.board.event_start_date,
            this.board.event_end_date,
            this.board.event_always
          )
          break
        case 'job':
          str =
            this.getDday(
              this.board.event_start_date,
              this.board.event_end_date,
              this.board.event_always
            ) !== ''
              ? this.getDday(
                  this.board.event_start_date,
                  this.board.event_end_date,
                  this.board.event_always
                )
              : '상시'
          break
        default:
          str = ''
          break
      }

      return str === null ? '' : str
    },
    removeTime() {
      return x => {
        if (x !== null) return moment(x).format('YYYY-MM-DD')
        else return x
      }
    },
    getDday() {
      return (s, e, a) => {
        s = this.removeTime(s)
        e = this.removeTime(e)
        if (s === null && e === null) return ''
        else if (a === '1') return '상시'
        else if (e === null || e === '') return '상시'
        else {
          const dif = moment(e).diff(moment(), 'days')
          return isNaN(dif)
            ? '상시'
            : `${s} ~ ${e} (${
                dif === 0 ? '오늘 마감' : dif > 0 ? `${dif}일 남음` : '마감'
              })`
        }
      }
    }
  },
  methods: {
    fetchBoard() {
      const id = window.location.href.split('/')
      const uri = `/api/board/content/?id=${id[id.length - 1]}`
      axios
        .post(uri)
        .then(response => {
          this.board = response.data.content
          if (this.board.public === 'N') {
            location.replace('/')
          }
        })
        .catch(() => {
          alert('잠시 후 다시 시도해주세요.')
        })
    },
    handlerClickBackButton() {
      if (!window.opener) {
        location.href = '/'
      } else {
        window.close()
      }
    },
    handlerClickHomeButton() {
      location.href = '/'
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_index.scss';

.background-container {
  background-color: #f8f8f8;
}
.simple-header {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 99;
}
.simple-header i {
  display: block;
  width: 24px;
  height: 24px;
  cursor: pointer;
  background: url(https://dcse8twossp9.cloudfront.net/static/img/v2/icon/arrow-back-black.svg)
    no-repeat center/cover;
  position: absolute;
  top: 50%;
  left: 24px;
  transform: translateY(-50%);
}
.simple-header span {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
.simple-header span.home {
  display: inline-block;
  font-size: 14px;
  line-height: 18px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 24px;
  cursor: pointer;
  font-weight: 400;
}
.default-container {
  width: 100%;
  max-width: 648px;
  min-height: calc(100vh);
  min-height: calc(var(--vh, 1vh) * 100);
  margin: 0 auto;
  background-color: #ffffff;
}
#boardViewPage {
  width: 100%;
  padding: 24px 24px 90px;
  margin: 0 auto;
  .top {
    display: none;
  }
  .title {
    font-size: 24px;
    font-weight: $medium;
    margin-bottom: 4px;
  }
  .subtitle {
    font-size: 20px;
    margin-bottom: 24px;
  }
  .info {
    display: flex;
    align-items: center;
    span {
      font-size: 16px;
      &.category {
        color: #000000;
        &.workout {
          color: $workout-color;
        }
        &.meditation {
          color: $meditation-color;
        }
        &.art {
          color: $art-color;
        }
        &.music {
          color: $music-color;
        }
      }
      &.date {
        color: #7d7d7d;
      }
      & + span {
        &::before {
          content: 'I';
          margin: 0 8px;
          font-size: 16px;
          color: #e1e1e1;
        }
      }
    }
  }
  .button {
    display: flex;
    align-items: center;
    margin-top: 12px;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      padding: 4px 12px;
      cursor: pointer;
      background-color: #000000;
      color: #ffffff;
    }
  }
  .contents {
    margin-top: 90px;
    &.pc {
      display: block;
    }
    &.mo {
      display: none;
    }
  }
  &::v-deep {
    #bottom-floating {
      @include flexBox(row, center, center);
      padding: 40px;
      position: fixed;
      width: calc(100% - 80px);
      bottom: 0;
      left: 0;
      background-color: #444444ca;
      .bottom-floating-max-width {
        @include flexBox(row, center, center);
        gap: 24px;
        width: 648px;
      }
      .floating-button {
        cursor: pointer;
        @include flexBox(row, center, center);
        flex: 1;
        font-size: 25px;
        font-weight: bold;
        line-height: 1.28;
        letter-spacing: -0.2px;
        text-align: center;
        padding: 20px;
        border-radius: 12px;
        background-image: linear-gradient(to right, #87d1ff, #c0fe64);
        text-align: center;
        &.button-download {
          &::before {
            content: '';
            width: 30px;
            height: 30px;
            display: block;
            margin-right: 8px;
            @include defaultIcon(
                'https://dcse8twossp9.cloudfront.net/static/img/board/down-icon.png'
            );
          }
        }
      }
    }
  }
}


@media all and (max-width: 768px) {
  #boardViewPage {
    padding: 24px;
    .top {
      display: block;
      font-size: 14px;
      color: #000000;
      margin-bottom: 24px;
      &.workout {
        color: $workout-color;
      }
      &.meditation {
        color: $meditation-color;
      }
      &.art {
        color: $art-color;
      }
      &.music {
        color: $music-color;
      }
    }
    .title {
      font-size: 20px;
      margin-bottom: 2px;
    }
    .subtitle {
      font-size: 16px;
      margin-bottom: 12px;
    }
    .info {
      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        &.category {
          display: none;
        }
        &.date {
          color: #7d7d7d;
        }
        & + span {
          &::before {
            display: none;
          }
        }
      }
    }
    .contents {
      margin-top: 60px;
      &.pc {
        display: none;
      }
      &.mo {
        display: block;
      }
    }

    &::v-deep {
      #bottom-floating {
        padding: 12px;
        width: calc(100% - 24px);
        .bottom-floating-max-width {
          gap: 12px;
          width: 100%;
        }
        .floating-button {
          width: unset;
          font-size: 15px;
          line-height: 2.67;
          letter-spacing: -0.72px;
          padding: 5px;
          &.button-download {
            &::before {
              content: '';
              width: 20px;
              height: 20px;
              margin-right: 3px;
            }
          }
        }
      }
    }
  }
}
</style>
